import styled from 'styled-components'
import Flex from 'styled-flex-component'

export const Wrapper = styled(Flex)`
  min-height: 22rem;
`
